/* tslint:disable */
/* eslint-disable */
/**
 * Flawtrack Backend
 * Flawtrack ASM
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * * `open` - Open
 * * `investigating` - Investigating
 * * `resolved` - Resolved
 * * `false_positive` - False Positive
 * @export
 */
export const DataLeakStatusEnum = {
    Open: 'open',
    Investigating: 'investigating',
    Resolved: 'resolved',
    FalsePositive: 'false_positive'
} as const;
export type DataLeakStatusEnum = typeof DataLeakStatusEnum[keyof typeof DataLeakStatusEnum];


export function instanceOfDataLeakStatusEnum(value: any): boolean {
    for (const key in DataLeakStatusEnum) {
        if (Object.prototype.hasOwnProperty.call(DataLeakStatusEnum, key)) {
            if (DataLeakStatusEnum[key as keyof typeof DataLeakStatusEnum] === value) {
                return true;
            }
        }
    }
    return false;
}

export function DataLeakStatusEnumFromJSON(json: any): DataLeakStatusEnum {
    return DataLeakStatusEnumFromJSONTyped(json, false);
}

export function DataLeakStatusEnumFromJSONTyped(json: any, ignoreDiscriminator: boolean): DataLeakStatusEnum {
    return json as DataLeakStatusEnum;
}

export function DataLeakStatusEnumToJSON(value?: DataLeakStatusEnum | null): any {
    return value as any;
}

export function DataLeakStatusEnumToJSONTyped(value: any, ignoreDiscriminator: boolean): DataLeakStatusEnum {
    return value as DataLeakStatusEnum;
}

